module.exports = __webpack_public_path__ + "img/11305.2d6e93ac.jpg";